import { Loader } from '@googlemaps/js-api-loader';

const element = document.querySelector('.js-map');

const loader = new Loader({
  apiKey: wordpress.googleApiKey,
  version: 'weekly',
  libraries: ['places'],
});

if (element) {
  loader.loadCallback(() => handleLoad());
}

const styles = [
  {
    featureType: 'administrative',
    elementType: 'all',
    stylers: [
      {
        saturation: '-100',
      },
    ],
  },
  {
    featureType: 'administrative.province',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: 65,
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: '50',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'all',
    stylers: [
      {
        saturation: '-100',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'all',
    stylers: [
      {
        lightness: '30',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'all',
    stylers: [
      {
        lightness: '40',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [
      {
        saturation: -100,
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        hue: '#ffff00',
      },
      {
        lightness: -25,
      },
      {
        saturation: -97,
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels',
    stylers: [
      {
        lightness: -25,
      },
      {
        saturation: -100,
      },
    ],
  },
];

function handleLoad() {
  //

  const position = {
    lat: Number(element.getAttribute('data-lat')),
    lng: Number(element.getAttribute('data-lng')),
  };

  const map = new google.maps.Map(element, {
    center: position,
    clickableIcons: false,
    styles,
    zoom: 15,
  });

  const icon = {
    url: `data:image/svg+xml;utf8,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 353.46 301.45" xml:space="preserve"><path fill="#F47B67" d="M127.02 8.54C70.44 52.81-17.84 86.41 4.38 137.67s28.69 163.63 104.59 144.9 139.31 42.39 159.21-69 7.87-163.63-27.31-187.28S149.7-9.2 127.02 8.54z"/><path fill="#274411" d="M333.66 235.91c-20.36-2.44-32.28 23.45-19.98 26.83 8.31 2.28 6.45 17.36-6.02 17.1-34.37-.72-62.1-30.58-97.14-44.36 4.4-16.6 39-145.1 40.94-155.39.01-.03.03-.06.03-.09 1.12-5.12-3.36-6.29-7.52-6.55-4.16-.26-15.59-.39-21.83.13-6.24.52-7.77 2.21-9.54 5.15-1.67 2.78-35.72 64.6-57.15 102.82 5.15-38.81 12.41-94.17 12.89-97.31.7-4.53.01-8.53-8.06-8.58-.06 0-.12.02-.18.02-15.14-.42-67.32-3.26-91.36 20.2-16.57 16.18-19.07 36.71-10.92 50.88 7.41 12.87 25.63 10.59 31.58-.39 8.77-16.18-11.35-17.04-8.38-31.38 1.13-5.45 13.99-20.14 46.38-19.96 1.57.36 3.11 1.68.37 6.14-10.68 17.39-25.73 49.68-30.65 58.45-6.12 10.9-28.19 57.52-53.53 60.84-19.28 2.52-23.44-20.45-4.29-20.86 18.32-.39 20.47-36.26-3.12-35.67-12.87.32-37.72 12.94-36.13 41.85 1.3 23.65 27.73 40.84 55.88 30.93 28.98-10.2 48.18-46.56 60.66-68.39 1.99-3.47 4.49-7.93 7.3-12.97-2.16 22.14-5.05 47.44-8.06 62.5-.78 3.9-2.08 8.84 2.86 8.58 4.94-.26 22.09 0 25.47 0 .98.13 1.88-.06 2.7-.48.33-.15.64-.34.92-.59 1.98-1.49 3.48-4.2 4.7-6.47 1.88-3.5 47.91-88.89 57.24-103.04-5.56 16.8-27.46 89.35-34.54 114.94-9.22-1.5-12.33 2.35-12.44 6.22-.11 4.07 2.47 7.93 5.36 7.45 26.53-6.27 34.04 20.04 67.67 39.82 45.09 26.51 83.81 17.67 102.38 4.68 22.6-15.84 19.38-50.19-4.49-53.05z"/></svg>`
    )}`,
    anchor: new google.maps.Point(35, 30), // anchor
    scaledSize: new google.maps.Size(70, 60),
  };

  const marker = new google.maps.Marker({ position, map, icon });
}
